import { Theme } from '../types';

export const areThemesEqual = (theme1: Theme, theme2: Theme): boolean => {
  return (Object.keys(theme1) as (keyof Theme)[]).every(
    (key) => theme1[key] === theme2[key],
  );
};
